<template>
    <div><!-- JobPageConfig has no template - it bears config for JobTemplate main fields and allow AB Testing --></div>
</template>
